import React from 'react';
import { Header } from "semantic-ui-react";

const ClientsHeader = ({ totalItemCount, visibleItemCount }) => {
    return (
        <Header as="h3">
            <span className="header uppercase">Manage Clients/Entities</span> - <span>{visibleItemCount}</span> of <span>{totalItemCount}</span>
        </Header>
    )
}

export default ClientsHeader